export default __webpack_public_path__ + "static/media/108.b22a3e45.jpg";